export async function execSearch(collection, params = {}) {
  const runtimeConfig = useRuntimeConfig()
  const domain = runtimeConfig.public.DOMAIN
  const searchHost = runtimeConfig.public.SEARCH_HOST
  const cookie = useCookie('ressources_user_token', {
    maxAge: 3600,
    domain,
  })
  try {
    const result = await $fetch(searchHost, {
      method: 'GET',
      query: {
        ...params,
        collection,
      },
      headers: {
        Authorization: cookie.value,
      },
    })
    if (typeof result.errors !== 'undefined') {
      throw new Error('Search error(s) occured', result.errors)
    }
    return {
      documents: result.hits,
      count: result.found,
    }
  } catch (error) {
    console.log(error)
    throw new Error('Search error(s) occured', error)
  }
}

export async function execAdvancedSearch(collection, params = {}) {
  const runtimeConfig = useRuntimeConfig()
  const advancedSearchHost = runtimeConfig.public.ADVANCED_SEARCH_HOST

  try {
    const result = await $fetch(advancedSearchHost, {
      method: 'GET',
      query: {
        ...params,
        collection,
      },
    })

    if (typeof result.errors !== 'undefined') {
      throw new Error('Search error(s) occured', result.errors)
    }
    return {
      documents: result.hits,
      count: result.found,
    }
  } catch (error) {
    console.log(error)
    throw new Error('Search error(s) occured', error)
  }
}
